/* eslint-disable react/jsx-props-no-spreading */
import React, { useMemo } from 'react';

import { FieldItemType, RadioValue } from 'types/componentTypes/Input';
import { FormInputProps } from 'types/componentTypes/FormBuilder';
import Input from '../../../Input';
import { inputComponents, inputTypes } from '../../utils';
import SelectDrawer from '../../../SelectDrawer';

const FormInput = (props: FormInputProps) => {
  const {
    name, label, rules, type, options, rows, accept, layout, values, disabled, componentProps,
    previewType, defaultFileList, placeholder, beforeUpload, onChange, required,
  } = props;

  const Component = useMemo(() => inputComponents[type || inputTypes.text], [type]);
  const isUpload = type === inputTypes.image || type === inputTypes.dragger;
  const isSelect = type === inputTypes.select || type === inputTypes.selectWithSearch;
  // Keep control-specific settings out of native input attributes.
  const specificProps = {
    ...(isUpload ? { accept, defaultFileList, beforeUpload } : {}),
    ...(type === inputTypes.dragger ? { previewType } : {}),
    ...(isSelect ? { showSearch: type === inputTypes.selectWithSearch } : {}),
    ...(isSelect || type === inputTypes.checkboxGroup || type === inputTypes.radioTags ? { options } : {}),
    ...(type === inputTypes.textArea ? { rows } : {}),
  };

  switch (type) {
    case inputTypes.addButton:
    case inputTypes.selectTags: {
      return (
        <Component
          type={type as FieldItemType}
          name={name}
          label={label}
          disabled={disabled}
          required={required}
        />
      );
    }
    case inputTypes.radio: {
      return (
        <Input
          label={label}
          layout={layout}
          rules={rules}
          name={name}
          required={required}
        >
          <Input.Radio disabled={disabled} values={values as RadioValue[]} />
        </Input>
      );
    }
    case inputTypes.selectDrawer: {
      return (
        <SelectDrawer
          form={componentProps!.form}
          drawerTitle={componentProps!.drawerTitle}
          columns={componentProps!.columns}
          dataSource={componentProps!.dataSource}
          options={componentProps!.options}
          filterBy={componentProps!.filterBy}
          placeholder={placeholder}
          name={name}
          rowKeyName={componentProps!.rowKeyName}
          label={label}
          required={required}
        />
      )
    }
    default: {
      return (
        <Input
          label={label}
          layout={layout}
          rules={rules}
          name={name}
          required={required}
        >
          <Component
            type={type as FieldItemType}
            disabled={disabled}
            placeholder={placeholder}
            autoComplete="off"
            onChange={onChange}
            {...specificProps}
          />
        </Input>
      );
    }
  }
}

FormInput.defaultProps = {
  options: null,
  type: 'text',
  accept: '.pdf',
  rules: [],
}

export default FormInput;
